import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const Breadcrumb = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const items: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    const cat = categories.find((c) => c.slug === pathSegments[1]);
    items.push({ label: cat?.name || '分类', path: `/category/${pathSegments[1]}` });
  } else if (pathSegments[0] === 'article' && pathSegments[1]) {
    const article = articles.find((a) => a.slug === pathSegments[1]);
    if (article) {
      const cat = categories.find((c) => c.slug === article.category);
      if (cat) {
        items.push({ label: cat.name, path: `/category/${cat.slug}` });
      }
    }
    items.push({ label: article?.title || '文章' });
  } else if (pathSegments[0] === 'about') {
    items.push({ label: '关于我们' });
  }

  if (items.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-50 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap text-sm text-foreground-500">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <span className="mx-2 text-foreground-300">/</span>
              )}
              {item.path && index < items.length - 1 ? (
                <Link
                  to={item.path}
                  className="hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={index === items.length - 1 ? 'text-foreground-800 font-medium' : ''}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;